<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="0"
            categoryName="VSD"
            categorySectionIcon="fa-bolt"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'vsd',
    components: { BaseInventory }
}
</script>
